import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'antd/lib/button';

export const ImportButton = ({ beginImport }) => (
    <Button
        onClick={() => {
            beginImport();
        }}
        type="primary"
    >
        <FormattedMessage id="imports.button.submit" />
    </Button>
);

ImportButton.propTypes = {
    beginImport: PropTypes.func.isRequired,
};
